var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ConstructionMaterial, KtsConstructionMaterialService, TaskTemplate } from './construction-material.service';
import { ConstructionTask, ConstructionTaskOtherField, DeliveryDestination, KtsConstructionTaskService } from './construction-task.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ValidationService } from '../../../../service/validation.service';
import { EventEmitter, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
var KtsConstructionMaterialComponent = /** @class */ (function (_super) {
    __extends(KtsConstructionMaterialComponent, _super);
    function KtsConstructionMaterialComponent(router, route, logger, action, message, page, service, constTaskService, colService, alertModalService, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.constTaskService = constTaskService;
        _this.colService = colService;
        _this.alertModalService = alertModalService;
        _this.validService = validService;
        _this.modalSubmit = new EventEmitter();
        /**
         * モーダル：選択中の番号。
         */
        _this.modalSelectedCode = 0;
        /**
         * モーダル：選択中のメーカー。
         */
        _this.modalSelectedManufacturer = 0;
        /**
         * モーダル：番号一覧。
         */
        _this.modalCodes = [];
        /**
         * モーダル：メーカー一覧。
         */
        _this.modalManufacturers = [];
        /**
         * モーダル：機器一覧。
         */
        _this.modalMaterials = [];
        /**
         * モーダル：選択中の機器一覧。
         */
        _this.modalSelectMaterials = [];
        /**
         * モーダル：表示したtask_m.id。
         */
        _this.modalTaskMId = null;
        _this.toggles = {};
        /**
         * task_m + task_other_field_m。
         */
        _this.taskItems = [];
        /**
         * task_u [task_m.id]。
         */
        _this.constructionItems = {};
        /**
         * task_other_field_u [task_other_field_m.id]。
         */
        _this.fieldItems = {};
        /**
         * delivery_destination [task_m.id]。
         */
        _this.deliveryDestinationItems = {};
        /**
         * material_m + material_element。
         */
        _this.materialItems = [];
        /**
         * material_m + material_element  [task_m.id]。
         */
        _this.materialMs = {};
        /**
         * material_u  [task_m.id][material_m.id]。
         */
        _this.constructionMaterialItems = {};
        _this.seq = 1;
        _this.readonly = false;
        _this.buttonDisp = true;
        return _this;
    }
    KtsConstructionMaterialComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.taskTemplate = new TaskTemplate(this.msgSnapshot, this.readonly);
        this.toggles = {};
    };
    KtsConstructionMaterialComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        var event = this.action.getEvent('materialSave');
        this.buttonDisp = ((typeof event.action === 'undefined') ? false : true);
    };
    KtsConstructionMaterialComponent.prototype.switchToggle = function (seq) {
        this.toggles[seq] = !this.toggles[seq];
    };
    KtsConstructionMaterialComponent.prototype.onMsg = function (msg) {
        this.taskTemplate = new TaskTemplate(msg, this.readonly);
    };
    KtsConstructionMaterialComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsConstructionMaterialComponent.prototype.onSubscribe = function (data) {
        if (typeof data.construction_m_id !== 'undefined') {
            this.constructionMId = data.construction_m_id;
            this.constructionItems = {};
            this.fieldItems = {};
            this.deliveryDestinationItems = {};
            for (var _i = 0, _a = this.taskItems; _i < _a.length; _i++) {
                var item = _a[_i];
                this.setTask(item);
                this.setDeliveryDestination(item);
                this.setField(item);
            }
            return;
        }
        if (typeof data.items === 'undefined' || !(data.items instanceof Array) || data.items.length === 0) {
            return;
        }
        data = JSOG.parse(JSON.stringify(data));
        // task_u
        if (typeof data.items[0].task_m_id !== 'undefined' && typeof data.items[0].is_complete !== 'undefined') {
            this.constructionItems = {};
            this.deliveryDestinationItems = {};
            var items = data.items;
            for (var _b = 0, items_1 = items; _b < items_1.length; _b++) {
                var item = items_1[_b];
                item.$type = "put" /* Put */;
                this.constructionItems[item.task_m_id] = item;
                if (item.delivery_destination !== null) {
                    this.deliveryDestinationItems[item.task_m_id] = item.delivery_destination;
                }
            }
            for (var _c = 0, _d = this.taskItems; _c < _d.length; _c++) {
                var item = _d[_c];
                this.setTask(item);
                this.setDeliveryDestination(item);
            }
        }
        // task_other_field_u
        if (typeof data.items[0].task_other_field_m_id !== 'undefined') {
            this.fieldItems = {};
            var items = data.items;
            for (var _e = 0, items_2 = items; _e < items_2.length; _e++) {
                var item = items_2[_e];
                item.$type = "put" /* Put */;
                this.fieldItems[item.task_other_field_m_id] = item;
            }
            for (var _f = 0, _g = this.taskItems; _f < _g.length; _f++) {
                var item = _g[_f];
                this.setField(item);
            }
        }
        // task_m
        if (typeof data.items[0].project_m_id !== 'undefined' && typeof data.items[0].template_type !== 'undefined') {
            this.taskItems = [];
            var items = data.items;
            this.seq = 1;
            for (var _h = 0, items_3 = items; _h < items_3.length; _h++) {
                var item = items_3[_h];
                if (item.template_type !== "estimate" /* estimate */ && item.template_type !== "order" /* order */ && item.template_type !== "completion" /* completion */) {
                    continue;
                }
                item.$seq = this.seq++;
                if (item.task_other_field_m && item.task_other_field_m.length > 0) {
                    this.constTaskService.sortItems(item.task_other_field_m);
                }
                this.taskItems.push(item);
                this.setTask(item);
                this.setDeliveryDestination(item);
                this.setField(item);
                this.setMaterial(item);
            }
        }
        // material_u
        if (typeof data.items[0].material_m_id !== 'undefined') {
            this.constructionMaterialItems = {};
            var items = data.items;
            for (var _j = 0, items_4 = items; _j < items_4.length; _j++) {
                var item = items_4[_j];
                var task = jsonpath.value(this.constructionItems, '$..[?(@.id==' + item.task_u_id + ')]');
                if (!task) {
                    continue;
                }
                if (typeof this.constructionMaterialItems[task.task_m_id] === 'undefined') {
                    this.constructionMaterialItems[task.task_m_id] = {};
                }
                item.$type = "put" /* Put */;
                this.constructionMaterialItems[task.task_m_id][item.material_m_id] = item;
            }
            for (var _k = 0, _l = this.taskItems; _k < _l.length; _k++) {
                var item = _l[_k];
                this.setMaterial(item);
            }
        }
        // material_m
        if (typeof data.items[0].manufacturers !== 'undefined' && typeof data.items[0].models !== 'undefined') {
            this.materialItems = data.items;
            for (var _m = 0, _o = this.taskItems; _m < _o.length; _m++) {
                var item = _o[_m];
                this.setMaterial(item);
            }
            this.modalMaterials = [];
            var codes = [];
            var manufacturers = [];
            for (var _p = 0, _q = this.materialItems; _p < _q.length; _p++) {
                var materialM = _q[_p];
                var code = materialM.id.toString();
                var display = this.join(' ', materialM.code, materialM.name, materialM.manufacturers, materialM.models);
                this.modalMaterials.push({ code: code, display: display });
                if (this.colService.checkVal(materialM.code)) {
                    codes.push(materialM.code);
                }
                if (this.colService.checkVal(materialM.manufacturers)) {
                    manufacturers.push(materialM.manufacturers);
                }
            }
            this.modalCodes = this.toOptions(codes);
            this.modalManufacturers = this.toOptions(manufacturers);
        }
    };
    /**
     * 文字列を結合する。
     * 空は除外する。
     *
     * @param separator 区切り文字
     * @param tokens トークン
     * @returns 結合結果
     */
    KtsConstructionMaterialComponent.prototype.join = function (separator) {
        var _this = this;
        var tokens = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            tokens[_i - 1] = arguments[_i];
        }
        return tokens.reduce(function (acc, token) {
            // 空は除外
            if (!_this.colService.checkVal(token)) {
                return acc;
            }
            // 初回
            if (!_this.colService.checkVal(acc)) {
                return token;
            }
            // 2回目以降
            return acc + separator + token;
        });
    };
    /**
     * Option[]に変換する。
     * 重複を排除し、ソートする。
     * codeは1から開始する。
     *
     * @param its 重複あり文字列配列
     * @returns Option[]
     */
    KtsConstructionMaterialComponent.prototype.toOptions = function (its) {
        return Array.from(new Set(its))
            .sort()
            .map(function (x, i) { return ({ code: i + 1, display: x }); });
    };
    KtsConstructionMaterialComponent.prototype.setTask = function (item) {
        if (typeof this.constructionItems[item.id] === 'undefined') {
            this.constructionItems[item.id] = Object.assign(new ConstructionTask(), {
                task_m_id: item.id,
                construction_m_id: this.constructionMId
            });
        }
    };
    KtsConstructionMaterialComponent.prototype.setDeliveryDestination = function (item) {
        if (typeof this.deliveryDestinationItems[item.id] === 'undefined') {
            this.deliveryDestinationItems[item.id] = Object.assign(new DeliveryDestination());
        }
    };
    KtsConstructionMaterialComponent.prototype.setField = function (item) {
        for (var _i = 0, _a = item.task_other_field_m; _i < _a.length; _i++) {
            var field = _a[_i];
            if (typeof this.fieldItems[field.id] === 'undefined') {
                this.fieldItems[field.id] = Object.assign(new ConstructionTaskOtherField(), {
                    task_other_field_m_id: field.id,
                    construction_m_id: this.constructionMId
                });
            }
        }
    };
    KtsConstructionMaterialComponent.prototype.setMaterial = function (item) {
        if (typeof this.constructionMaterialItems[item.id] === 'undefined') {
            this.constructionMaterialItems[item.id] = {};
        }
        for (var _i = 0, _a = this.materialItems; _i < _a.length; _i++) {
            var material = _a[_i];
            if (typeof this.constructionMaterialItems[item.id][material.id] === 'undefined') {
                this.constructionMaterialItems[item.id][material.id] = Object.assign(new ConstructionMaterial(), {
                    material_m_id: material.id,
                    construction_m_id: this.constructionMId,
                    task_m_id: item.id
                });
            }
        }
        var materialMs = [];
        for (var _b = 0, _c = this.materialItems; _b < _c.length; _b++) {
            var material = _c[_b];
            var mu = this.constructionMaterialItems[item.id][material.id];
            if ((material.type === "normal" /* normal */ && !this.colService.checkVal(mu.quantity))
                || (material.type === "special" /* special */ && !this.colService.checkVal(mu.special_notes) && !this.colService.checkVal(mu.quantity) && !this.colService.checkVal(mu.special_unit))) {
                continue;
            }
            materialMs.push(material);
        }
        this.materialMs[item.id] = materialMs;
    };
    KtsConstructionMaterialComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    KtsConstructionMaterialComponent.prototype.onEventSubscribe = function (e) {
        var reg = new RegExp('^' + this.componentName + '#button(\\d+)$');
        var result = e.match(reg);
        if (result !== null) {
            var taskMid = parseInt(result[1]);
            this.setCompRec(taskMid);
            // 必須チェック
            var event_1 = this.action.getEvent('materialSave');
            if (typeof event_1.action === 'undefined') {
                return;
            }
            var valid = this.validService.validation('submit', event_1, this.action.getCompRec(), this.msgSnapshot);
            if (!valid.validation) {
                return;
            }
            // 「数量」チェック
            var materialMids = this.getMaterialMidsWithNoQuantity(taskMid);
            if (this.colService.checkVal(materialMids)) {
                // 「数量」未入力のアラートモーダルを表示
                var additions = " (" + this.join.apply(this, [', '].concat(materialMids)) + ")";
                this.alertModalService.open({
                    message: this.msgSnapshot['au.COMPONENT.KtsConstructionMaterialComponent.Modal.required.quantity'] + additions,
                    buttons: [{
                            class: 'ok',
                            caption: this.msgSnapshot['Modal.button.ok']
                        }]
                });
                return;
            }
            // 確認のアラートモーダルを表示
            this.alertModalService.open({
                message: this.msgSnapshot['au.COMPONENT.KtsConstructionMaterialComponent.Modal.save.confirm'],
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#save#ok',
                        caption: this.msgSnapshot['Modal.button.ok']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#save#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
            return;
        }
        else if (e === this.componentName + '#save#ok') {
            // 機器情報保存
            this.action.firstAction('materialSave');
            return;
        }
        // 選択
        var match = e.match(new RegExp('^' + this.componentName + '#open(\\d+)$'));
        if (match != null) {
            this.modalOnOpen(Number(match[1]));
            return;
        }
    };
    /**
     * 数量が無いmaterial_m.idを取得する。
     *
     * @param taskMId task_m.id
     * @returns 数量が無いmaterial_m.id
     */
    KtsConstructionMaterialComponent.prototype.getMaterialMidsWithNoQuantity = function (taskMId) {
        var allMaterialUs = this.constructionMaterialItems[taskMId];
        var materialUs = [];
        for (var _i = 0, _a = this.materialMs[taskMId]; _i < _a.length; _i++) {
            var materialIM = _a[_i];
            materialUs.push(allMaterialUs[materialIM.id]);
        }
        return materialUs
            .filter(function (x) { return x != null && x.quantity == null; })
            .map(function (x) { return x.material_m_id.toString(); });
    };
    KtsConstructionMaterialComponent.prototype.onEvent = function (e1, e2, r) {
    };
    KtsConstructionMaterialComponent.prototype.onChange = function (e, key) {
        if (typeof e.val !== 'undefined') {
            this.constructionItems[key][e.key] = e.val;
        }
    };
    KtsConstructionMaterialComponent.prototype.onChangeDeliveryDestination = function (e, key) {
        if (typeof e.val !== 'undefined') {
            this.deliveryDestinationItems[key][e.key] = e.val;
        }
    };
    KtsConstructionMaterialComponent.prototype.onChangeField = function (e, key) {
        this.fieldItems[key][e.key] = e.val;
    };
    KtsConstructionMaterialComponent.prototype.onChangeMaterial = function (e, key) {
        this.constructionMaterialItems[key] = e;
    };
    KtsConstructionMaterialComponent.prototype.setCompRec = function (id) {
        var constructionData = JSOG.parse(JSON.stringify(this.constructionItems[id]));
        delete constructionData.construction_documents;
        constructionData.delivery_destination = JSOG.parse(JSON.stringify(this.deliveryDestinationItems[id]));
        if (typeof constructionData.delivery_destination !== 'undefined') {
            var delCols = ['cdate', 'cby', 'udate', 'uby', 'base_status'];
            for (var _i = 0, delCols_1 = delCols; _i < delCols_1.length; _i++) {
                var delCol = delCols_1[_i];
                if (typeof constructionData.delivery_destination[delCol] !== 'undefined') {
                    delete constructionData.delivery_destination[delCol];
                }
            }
        }
        var fieldIds = this.taskItems.filter(function (x) { return x.id === id; }).map(function (x) { return x.task_other_field_m; })[0].map(function (x) { return x.id; });
        var fieldData = [];
        var fieldItems = JSOG.parse(JSON.stringify(this.fieldItems));
        for (var _a = 0, fieldIds_1 = fieldIds; _a < fieldIds_1.length; _a++) {
            var fieldId = fieldIds_1[_a];
            var field = fieldItems[fieldId];
            if (!field.value) {
                if (typeof field.id === 'undefined') {
                    continue;
                }
                else {
                    field.$type = "delete" /* Delete */;
                }
            }
            fieldData.push(field);
        }
        var constructionMaterialData = [];
        var constructionMaterialItems = JSOG.parse(JSON.stringify(this.constructionMaterialItems[id]));
        for (var _b = 0, _c = this.materialItems; _b < _c.length; _b++) {
            var material = _c[_b];
            var constructionMaterial = constructionMaterialItems[material.id];
            if ((material.type === "normal" /* normal */ && !this.colService.checkVal(constructionMaterial.quantity))
                || (material.type === "special" /* special */ && !this.colService.checkVal(constructionMaterial.special_notes) && !this.colService.checkVal(constructionMaterial.quantity) && !this.colService.checkVal(constructionMaterial.special_unit))) {
                if (!this.colService.checkVal(constructionMaterial.quantity)) {
                    if (typeof constructionMaterial.id === 'undefined') {
                        continue;
                    }
                    else {
                        constructionMaterial.$type = "delete" /* Delete */;
                    }
                }
            }
            constructionMaterialData.push(constructionMaterial);
        }
        this.action.setCompRec(this.componentName, { items: [constructionData] });
        this.action.setCompRec(this.componentName + '#field', { items: fieldData });
        this.action.setCompRec(this.componentName + '#material', { items: constructionMaterialData });
    };
    /**
     * 機器選択モーダルの表示。
     *
     * @param modalTaskMId task_m.id
     */
    KtsConstructionMaterialComponent.prototype.modalOnOpen = function (modalTaskMId) {
        this.modalSelectedCode = 0;
        this.modalSelectedManufacturer = 0;
        this.modalTaskMId = modalTaskMId;
        $(this.element).multiSelect('deselect_all');
        var select = [];
        for (var _i = 0, _a = this.materialMs[this.modalTaskMId]; _i < _a.length; _i++) {
            var materialIM = _a[_i];
            select.push(materialIM.id.toString());
        }
        $(this.element).multiSelect('select', select);
        this.modalSelectMaterials = select;
        $(this.element).multiSelect('refresh');
        this.remodal.open();
    };
    /**
     * 機器選択モーダルの機器選択。
     */
    KtsConstructionMaterialComponent.prototype.modalOnSelect = function () {
        this.remodal.close();
        var materialMs = [];
        for (var _i = 0, _a = this.materialItems; _i < _a.length; _i++) {
            var materialM = _a[_i];
            if (this.modalSelectMaterials.indexOf(materialM.id.toString()) < 0) {
                // 非選択
                var materialU = this.constructionMaterialItems[this.modalTaskMId][materialM.id];
                materialU.quantity = null;
                materialU.special_unit = null;
                materialU.special_notes = null;
                continue;
            }
            // 選択
            materialMs.push(materialM);
        }
        this.materialMs[this.modalTaskMId] = materialMs;
        this.setCompRec(this.modalTaskMId);
    };
    /**
     * 機器選択モーダルの番号選択。
     *
     * @param event イベント
     */
    KtsConstructionMaterialComponent.prototype.modalOnChangeCode = function (event) {
        var option = this.modalCodes.find(function (x) { return x.code.toString() === event.val; });
        this.modalSelectedCode = option ? option.code : 0;
        $(this.element).multiSelect('refresh');
    };
    /**
     * 機器選択モーダルのメーカー選択。
     *
     * @param event イベント
     */
    KtsConstructionMaterialComponent.prototype.modalOnChangeManufacturer = function (event) {
        var option = this.modalManufacturers.find(function (x) { return x.code.toString() === event.target.value; });
        this.modalSelectedManufacturer = option ? option.code : 0;
        $(this.element).multiSelect('refresh');
    };
    KtsConstructionMaterialComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.modal = this.remodalElement.nativeElement;
        this.remodal = $(this.modal).remodal({ hashTracking: false });
        var self = this;
        this.element = this.multiSelectElement.nativeElement;
        this.modalSelectMaterials = [];
        $(this.element).multiSelect({
            afterInit: function (container) {
                var selector = "#" + this.$container.attr('id') + " .ms-elem-selectable:not(.ms-selected)";
                $(selector).hide();
                var code = self.modalCodes.find(function (x) { return x.code === self.modalSelectedCode; });
                var manufacturer = self.modalManufacturers.find(function (x) { return x.code === self.modalSelectedManufacturer; });
                // 選択番号と選択メーカーが一致するか
                var match = function (x) {
                    if (code && manufacturer) {
                        return x.code === code.display && x.manufacturers === manufacturer.display;
                    }
                    if (code) {
                        return x.code === code.display;
                    }
                    if (manufacturer) {
                        return x.manufacturers === manufacturer.display;
                    }
                    return true;
                };
                self.materialItems.forEach(function (x) { return match(x) && $(selector + "[data-code=\"" + x.id + "\"]").show(); });
            },
            afterSelect: function (values) {
                if (values && values[0]) {
                    self.modalSelectMaterials.push(values[0]);
                }
            },
            afterDeselect: function (values) {
                if (values && values[0]) {
                    var idx = self.modalSelectMaterials.indexOf(values[0]);
                    if (idx >= 0) {
                        self.modalSelectMaterials.splice(idx, 1);
                    }
                }
                $(self.element).multiSelect('refresh');
            }
        });
        this.multiSelectOptions.changes.subscribe(function (t) {
            $(_this.element).multiSelect('refresh');
        });
    };
    KtsConstructionMaterialComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    KtsConstructionMaterialComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-construction-material',
                    template: "<form id=\"{{ componentName }}\">\n  <p *ngIf=\"taskItems.length === 0\">{{ (msg | async)['au.COMPONENT.KtsConstructionMaterialComponent.label.noTask'] }}</p>\n  <div *ngFor=\"let taskItem of taskItems; let index = index;\" class=\"row\" [class.-mb-1]=\"index < taskItems.length - 1\">\n    <div class=\"col-sm-12\">\n      <div class=\"filter\">\n        <p class=\"filter_trigger\">\n          <!-- \u30BF\u30B9\u30AF\u540D -->\n          <span [class.open]=\"toggles[taskItem.$seq]\" (click)=\"switchToggle(taskItem.$seq)\">{{ taskItem.name }}</span>\n        </p>\n        <div class=\"-m-1 -mb-2\" [style.display]=\"toggles[taskItem.$seq] ? 'block': 'none'\">\n          <ul class=\"form form-campaign\">\n            <li class=\"stageFlowPane\">\n              <div class=\"stageFlowPane_border\">\n                <!-- \u65E5\u4ED8 -->\n                <div *ngFor=\"let col of taskTemplate.date; let colIndex = index;\" class=\"row -m-1\" [class.-mt-2]=\"colIndex > 0\">\n                  <div class=\"col-sm-12\">\n                    <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"col\" [val]=\"constructionItems[taskItem.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, taskItem.id)\"></column>\n                  </div>\n                </div>\n                <!-- \uFF3B\u9078\u629E\uFF3D\u30DC\u30BF\u30F3 -->\n                <div class=\"row -m-1 -mt-2\" *ngIf=\"!readonly\">\n                  <div class=\"col-sm-12\">\n                    <btn\n                        [componentName]=\"componentName + '#openButton' + taskItem.id\"\n                        [component]=\"{\n                          params: {\n                            buttons: [{\n                              type: 'button',\n                              event: componentName + '#open' + taskItem.id,\n                              caption: (msg | async)['Button_select']\n                            }]\n                          }\n                        }\"></btn>\n                  </div>\n                </div>\n                <!-- \u6A5F\u5668\u4E00\u89A7 -->\n                <div class=\"row -m-1 -mt-2\">\n                  <div class=\"col-sm-12\">\n                    <kts-construction-material-list\n                        [componentName]=\"componentName + '#material' + taskItem.$seq\"\n                        [component]=\"{name: componentName + '#material' + taskItem.$seq, params: {primaryKey: 'id'}}\"\n                        [normalCols]=\"taskTemplate.materialNormal\"\n                        [specialCols]=\"taskTemplate.materialSpecial\"\n                        [materials]=\"materialMs[taskItem.id]\"\n                        [constMaterials]=\"constructionMaterialItems[taskItem.id]\"\n                        (changeMaterial)=\"onChange($event, taskItem.id)\"></kts-construction-material-list>\n                  </div>\n                </div>\n                <!-- \u6A5F\u5668\u767A\u6CE8\u306E\u5834\u5408 -->\n                <ng-template [ngIf]=\"taskItem.template_type === 'order'\">\n                  <div *ngFor=\"let col of taskTemplate.deliveryDestination\" class=\"row -m-1 -mt-2\">\n                    <div class=\"col-sm-12\">\n                      <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"col\" [val]=\"deliveryDestinationItems[taskItem.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeDeliveryDestination($event, taskItem.id)\"></column>\n                    </div>\n                  </div>\n                </ng-template>\n                <!-- \u5099\u8003 -->\n                <div *ngFor=\"let field of taskItem.task_other_field_m\" class=\"row -m-1 -mt-2\">\n                  <div class=\"col-sm-12\">\n                    <column [key]=\"'form'\" [componentName]=\"componentName + '#field'\" [index]=\"taskItem.$seq\" [col]=\"{\n                      label: field.name,\n                      key: 'value',\n                      controlType: 'text',\n                      readonly: readonly,\n                      params: {formClass: {width: '100per'}}\n                    }\" [val]=\"fieldItems[field.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeField($event, field.id)\"></column>\n                  </div>\n                </div>\n                <!-- \uFF3B\u4FDD\u5B58\uFF3D\u30DC\u30BF\u30F3 -->\n                <div *ngIf=\"buttonDisp\" class=\"row -m-1 -mt-2\">\n                  <div class=\"col-sm-12\">\n                    <btn [componentName]=\"componentName + '#button' + taskItem.id\"\n                         [component]=\"{\n                            params: {\n                              buttons: [{\n                                type: 'button',\n                                event: componentName + '#button' + taskItem.id,\n                                caption: (msg | async)['Button_save']\n                              }]\n                            }\n                         }\"></btn>\n                  </div>\n                </div>\n              </div>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n\n\n  <!-- remodal -->\n  <div class=\"remodal\" id=\"{{ componentName + '#MultiSelect' }}\" #remodal>\n    <div class=\"remodal_whitebg\">\n      <p class=\"sectionHeading\">{{ (msg | async)['au.COMPONENT.KtsConstructionMaterialComponent.select_material_modal.label.title'] }}</p>\n      <div class=\"ms-container_divisionWrapper\">\n        <!-- \u756A\u53F7 -->\n        <p class=\"ms-container_division\">\n          <column [key]=\"'form'\" [col]=\"{\n            key: 'modalSelectedCode',\n            controlType: 'select2',\n            params: {\n              placeholder: (msg | async)['au.COMPONENT.KtsConstructionMaterialComponent.select_material_modal.label.code.unselected'],\n              options: modalCodes\n            }\n          }\" [val]=\"this\" [msg]=\"(msg | async)\" (setChangeVal)=\"modalOnChangeCode($event)\"></column>\n        </p>\n        <!-- \u30E1\u30FC\u30AB\u30FC -->\n        <p class=\"ms-container_division\">\n          <select (change)=\"modalOnChangeManufacturer($event)\">\n            <option value=\"0\" [selected]=\"modalSelectedManufacturer === 0\">{{ (msg | async)['au.COMPONENT.KtsConstructionMaterialComponent.select_material_modal.label.manufacturer.unselected'] }}</option>\n            <option *ngFor=\"let option of modalManufacturers\" [value]=\"option.code\" [selected]=\"modalSelectedManufacturer === option.code\">{{ option.display }}</option>\n          </select>\n        </p>\n      </div>\n      <!-- \u6A5F\u5668 -->\n      <div class=\"ms-containerWrapper\">\n        <select multiple=\"multiple\" #multiSelect>\n          <option *ngFor=\"let option of modalMaterials\" [value]=\"option.code\"  [attr.data-code]=\"option.code\" #multiSelectOptions>\n            <label>{{ option.display }}</label>\n          </option>\n        </select>\n      </div>\n    </div>\n    <div class=\"remodal_btns\">\n      <ul class=\"remodal_btns_group\">\n        <li>\n          <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"modalOnSelect()\">{{ (msg | async)['au.COMPONENTS.modal.button.decide'] }}</button>\n        </li>\n        <li>\n          <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\">{{ (msg | async)['au.COMPONENTS.modal.button.close'] }}</button>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <!-- /remodal -->\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsConstructionMaterialComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsConstructionMaterialService },
        { type: KtsConstructionTaskService },
        { type: ColumnService },
        { type: AlertModalService },
        { type: ValidationService }
    ]; };
    KtsConstructionMaterialComponent.propDecorators = {
        modalSubmit: [{ type: Output }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }],
        multiSelectElement: [{ type: ViewChild, args: ['multiSelect',] }],
        multiSelectOptions: [{ type: ViewChildren, args: ['multiSelectOptions',] }]
    };
    return KtsConstructionMaterialComponent;
}(ContentBaseComponent));
export { KtsConstructionMaterialComponent };
//# sourceMappingURL=construction-material.component.js.map